import React, {Component} from 'react';
import {Row, Col, InputGroup, Label, Button} from "reactstrap";
import {observer} from "mobx-react";
import CalendarioPicker from '../../../comum/components/Calendario';
import {FecharFiltro, Filtro} from "../../../comum/components/Icones";
import FormSelectSimples from "../../../comum/components/FormSelectSimples";
import Card from "../../../comum/components/Card";
import FiltrosImportacaoStore from "../stores/FiltrosImportacaoStore";
import FormInputSimples from "../../../comum/components/FormInputSimples";
import InputFiltro from "../../../comum/components/InputFiltro";
import lscache from 'lscache';

@observer
export default class FiltrosImportacao extends Component {
    constructor(props) {
        super(props);
        
        this.controllerImportacao = this.props.controller;
        this.controller = new FiltrosImportacaoStore();

        this.state = { maisFiltros: false, filtrado: false };
    }
    
    componentDidMount () {
        const pesquisa = lscache.get('acompProcesso-pesquisa-doc');
        lscache.set('acompProcesso-pesquisa-voltar', 5);
        if (pesquisa) 
            this.handleFiltrar();        
    }

    handleFiltrar = () => {

        this.setState(state => ({filtrado: true}));

        const pesquisa = lscache.get('acompProcesso-pesquisa-doc');        
        if (pesquisa) {
            const documentoBL = lscache.get('acompProcesso-importacao-doc');
            _.set(this.controller.filtros, "bl", documentoBL ? documentoBL : null);
        };        

        if (this.validar()){
            if (!this.state.maisFiltros) {
                this.controllerImportacao.listarImportacoes({bl: this.controller.filtros.bl});
            } else {
                this.controller.filtros.operacao = this.controller.filtroNavio ? this.controller.filtroNavio.value : null;
                this.controller.filtros.situacao = this.controller.filtroSituacao ? this.controller.filtroSituacao.value : null;
                this.controller.filtros.maisFiltros = this.state.maisFiltros;
                this.controller.filtros.dataInicial = this.controller.dataInicial;
                this.controller.filtros.dataFinal = this.controller.dataFinal;
                this.controllerImportacao.listarImportacoes(this.controller.filtros);
            }
        }
    };

    validar = () => {
        //Mantida a chamada do metodo
        return true;
    };

    filtros = () => {
        if (!this.state.maisFiltros) {
            return this.filtrosBasicos();
        } else {
            return this.filtrosCompletos();
        }
    };

    filtrosBasicos = () => {
        let xl = 2; let lg = 4; let md = 4;
        return <React.Fragment>
            <InputFiltro titulo="BL" xl={xl} lg={lg} md={md} sm={12} xs={12} value={lscache.get('acompProcesso-pesquisa-doc') ? lscache.get('acompProcesso-importacao-doc') : ""}
                         onEnter={() => this.handleFiltrar()}
                         onChange = { (event) => this.controller.onChangeFiltro("bl", event) }
            />
            <Col className={ `col-botoes ${(!this.validar() && this.state.filtrado) ? "filtrado" : ""}` } xl={3} lg={3} md={3} sm={12} xs={12}>
                <Button className="btn-filtros" onClick={ () => this.mudaFiltros() } outline>
                    <Filtro color="#93A0AD" className="mr-2" width="15" height="15"/>
                    Mais filtros
                </Button>
                <Button className="btn-com-bordas-primary btn-filtrar" onClick={ () => this.handleFiltrar() }>Filtrar</Button>
            </Col>
        </React.Fragment>
    };

    filtrosCompletos = () => {
        let xl = 2; let lg = 4; let md = 4;
        return <React.Fragment>
            <InputFiltro titulo="BL" xl={xl} lg={lg} md={md} sm={12} xs={12} value={lscache.get('acompProcesso-pesquisa-doc') ? lscache.get('acompProcesso-importacao-doc') : ""}
                         onEnter={() => this.handleFiltrar()}
                         onChange = { (event) => this.controller.onChangeFiltro("bl", event) }
            />
            <Col xl={xl} lg={lg} md={md} sm={12} xs={12} className="mb-4">
                <div className="w-100">
                    <Col xs={12} className="col-label px-0">
                        <Label>Período</Label>
                    </Col>
                    <Col xs={12} className="px-0">
                        <InputGroup className={'ativo'}>
                            <CalendarioPicker onChangeInicio={valor => this.controller.onChangeDataInicio(valor)}
                                              onChangeFim={valor => this.controller.onChangeDataFim(valor)}
                                              dataInicial={this.controller.dataInicial}
                                              dataFinal={this.controller.dataFinal}
                                              close={true}
                                              filtrar={() => {}}/>
                        </InputGroup>
                    </Col>
                </div>
            </Col>
            <FormSelectSimples titulo="Situação" xl={xl} lg={lg} md={md} sm={12} xs={12}
                               itens={ this.controller.situacoesFiltros }
                               dado={ this.controller.filtroSituacao }
                               bloqueado={!this.controller.situacoesFiltros}
                               onChange={ (event) => this.controller.onChangeFiltroSituacao(event) } />
            <FormSelectSimples titulo="Navio" xl={xl} lg={lg} md={md} sm={12} xs={12}
                               itens={ this.controller.naviosFiltros }
                               dado={ this.controller.filtroNavio }
                               bloqueado={!this.controller.naviosFiltros}
                               onChange={ (event) => this.controller.onChangeFiltroNavios(event) } />
            <FormInputSimples titulo="CE" xl={xl} lg={lg} md={md} sm={12} xs={12}
                              onEnter={() => this.handleFiltrar()}
                              onChange = { (event) => this.controller.onChangeFiltro("ce", event) }
            />
            <Col className="col-botoes" xl={xl} md={md} sm={12} xs={12}>
                <Button className="btn-filtros ativo" onClick={ () => this.mudaFiltros() } outline>
                    <FecharFiltro color="#93A0AD" className="mr-2" width="15" height="15"/>
                    Menos filtros
                </Button>
                <Button className="btn-com-bordas-primary btn-filtrar" onClick={ () => this.handleFiltrar() }>Filtrar</Button>
            </Col>
        </React.Fragment>
    };

    mudaFiltros = () => {
        this.setState({maisFiltros: !this.state.maisFiltros});
    };

    render() {
        return (
            <div className={ this.controllerImportacao.detalhesAtivo ? "escondido" : "filtro-card" } >
                <Card className={"area-form pb-0"}>
                    <Row className="pb-0">
                        { this.filtros() }
                    </Row>
                </Card>
            </div>)
    }
}


// WEBPACK FOOTER //
// ./src/modules/liberacoes/importacao/components/FiltrosImportacao.js